
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-37b614ae&scoped=true!stylus-loader?sourceMap!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./book.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./book.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-37b614ae!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./book.vue"),
  /* scopeId */
  "data-v-37b614ae",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/book/book.vue
// module id = 43
// module chunks = 1